import { TEN_MINUTES_IN_MS } from '@protector/utils/constants';
import type { UUID } from '@protector/utils/types';
import { useQuery } from '@tanstack/react-query';
import { WorkspaceQueryKey } from './constants.ts';
import { getWorkspaceInfo } from './services.ts';

export function useGetWorkspace(workspaceId?: UUID) {
  return useQuery({
    queryKey: [WorkspaceQueryKey.GET_WORKSPACE, workspaceId],
    queryFn: () => getWorkspaceInfo(workspaceId ?? ''),
    enabled: !!workspaceId,
    staleTime: TEN_MINUTES_IN_MS,
    cacheTime: TEN_MINUTES_IN_MS
  });
}
